import jwt from 'jsonwebtoken'

export const TOKEN_KEY = 'authtoken'

export const token = () => {
  return localStorage.getItem(TOKEN_KEY)

  // Conta PF
  // return 'eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjkxNDg1OSIsIm5hbWUiOiJsZW82QHRlc3RlLmNvbSIsInVzZXJOYW1lIjoiTGVvbmFyZG8gTmFzY2ltZW50byIsInVzZXJOYW1lV2VsY29tZSI6Ikxlb25hcmRvIE5hc2NpbWVudG8gICAgICAgICAgICIsInNvY2lhbE5ldHdvcmsiOiJmYWxzZSIsImVtYWlsIjoibGVvNkB0ZXN0ZS5jb20iLCJ0aXBvQ2xpZW50ZSI6IkYiLCJpbnNjcmljYW9Fc3RhZHVhbCI6IiIsImNucGoiOiIgICAgICAgICAgICAgICAiLCJjcGYiOiI2MTk2NDY5MDAyMSAgICIsImlkQXRpdmlkYWRlIjoiMCIsImlkU3ViQXRpdmlkYWRlIjoiMCIsImlkVmVuZGVkb3IiOiIiLCJzZWxsZXJOYW1lIjoiIiwicG9kZUVmZXR1YXJQZWRpZG8iOiJGYWxzZSIsImRkZFRlbGVmb25lUHJpbmNpcGFsIjoiICAgICIsIm51bWVyb1RlbGVmb25lUHJpbmNpcGFsIjoiICAgICAgICAiLCJkZGRUZWxlZm9uZVNlY3VuZGFyaW8iOiI0NCAgIiwibnVtZXJvVGVsZWZvbmVTZWN1bmRhcmlvIjoiNDE0MTQxNDE0IiwiZGRkVGVsZWZvbmVDb21lcmNpYWwiOiIgICAgIiwibnVtZXJvVGVsZWZvbmVDb21lcmNpYWwiOiIgICAgICAgICIsImRkZFRlbGVmb25lRmF4IjoiICAgICIsIm51bWVyb1RlbGVmb25lRmF4IjoiICAgICAgICAgIiwiY29kaWdvQ25hZSI6IiIsInBlcm1pdGVOZWdvY2lhckFjaW1hRmFpeGEiOiJGYWxzZSIsIm5iZiI6MTY2OTMxNDA2NiwiZXhwIjoxNjg0ODY2MDY2LCJpc3MiOiJodHRwOi8vaG1sd3d3LmdpbWJhLmNvbS5iciIsImF1ZCI6IkdpbWJhLkxvZ2luIn0.3TELOlMR8n7e9lc9E96X6Sex5vYtYzokvxAtc0SxhOM'

  //Conta PJ
  // return 'eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEwNTQ4MjUiLCJuYW1lIjoidGVzdGVjYWRhc3Ryb1BqQGdtYWlsLmNvbSIsInVzZXJOYW1lIjoiTGFpYW5lIFRvbGRvIiwidXNlck5hbWVXZWxjb21lIjoiTGFpYW5lIFRvbGRvICAgICAgICAgICAgICAgICAgIiwic29jaWFsTmV0d29yayI6ImZhbHNlIiwiZW1haWwiOiJ0ZXN0ZWNhZGFzdHJvUGpAZ21haWwuY29tIiwidGlwb0NsaWVudGUiOiJKIiwiaW5zY3JpY2FvRXN0YWR1YWwiOiIyNDI4MTAxNjQ0OTkiLCJjbnBqIjoiNDQ0MjY2ODIwMDAxNzQgIiwiY3BmIjoiICAgICAgICAgICAgICAiLCJpZEF0aXZpZGFkZSI6IjE0IiwiaWRTdWJBdGl2aWRhZGUiOiIxNDAyIiwiaWRWZW5kZWRvciI6IiIsInNlbGxlck5hbWUiOiIiLCJwb2RlRWZldHVhclBlZGlkbyI6IkZhbHNlIiwiZGRkVGVsZWZvbmVQcmluY2lwYWwiOiIgICAgIiwibnVtZXJvVGVsZWZvbmVQcmluY2lwYWwiOiIgICAgICAgICIsImRkZFRlbGVmb25lU2VjdW5kYXJpbyI6IiAgICAiLCJudW1lcm9UZWxlZm9uZVNlY3VuZGFyaW8iOiIgICAgICAgICAiLCJkZGRUZWxlZm9uZUNvbWVyY2lhbCI6IjExICAiLCJudW1lcm9UZWxlZm9uZUNvbWVyY2lhbCI6IjU1NTU2OTQ3IiwiZGRkVGVsZWZvbmVGYXgiOiIxMSAgIiwibnVtZXJvVGVsZWZvbmVGYXgiOiI5NDcwODUwNTgiLCJjb2RpZ29DbmFlIjoiIiwicGVybWl0ZU5lZ29jaWFyQWNpbWFGYWl4YSI6IkZhbHNlIiwibmJmIjoxNjg1NjI5Mjk5LCJleHAiOjE3MDExODEyOTksImlzcyI6Imh0dHA6Ly9obWx3d3cuZ2ltYmEuY29tLmJyIiwiYXVkIjoiR2ltYmEuTG9naW4ifQ.13-w4kJF8BuVplM7XcvzOppHKHSJAG2eCyBaM9SxxoU'
}

export const isAuthenticated = () =>
  typeof window !== 'undefined' ? token() !== null : false

export const getToken = () => (typeof window !== 'undefined' ? token() : '')

export const login = (token) => {
  if (!!token) {
    localStorage.setItem(TOKEN_KEY, token)
  }
}

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY)
}

export const authCheck = (elseAction = () => undefined) => {
  const userToken = token()
  if (userToken === null)
    return (window.location.href = `${process.env.REACT_APP_URL_MAIN}/Marketplacecliente/meuperfil`)
  // const user = jwt.decode(userToken)
  // if (user?.cpf === undefined) return logout()
  return elseAction()
}

export const isPF = () => {
  const userToken = token()
  const user = jwt.decode(userToken)
  // console.log(user)
  if (user?.cpf?.trim().length > 0) return true
  return false
}
